// Full-document render of the anonymous order-STATUS page
// (/store/accounts/order-status/<number>/<hash>/): PageSkeleton wrapping the
// legacy stearns anon_order layout -- the "Order: {number}" heading, the
// AccountRichOrder block (fed the shared serialize_rich_order_detail data
// flattened on the page props), the two legacy empty states, and the
// customer-service info block. The rich block uses the site-local
// AccountRichOrder markup, NOT the shared RichOrderDetail: it renders the
// legacy .accordion / .accordion-target class contract the shared component
// does not emit, with the order-details disclosure owned by AccountRichOrder's
// own state. The track_order_lookup dataLayer events push after hydration so
// the body stays script-free for full-document hydration.
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { AccountRichOrderBody } from "../components/AccountRichOrder";
import { CustomerServiceInfoBlock } from "../components/CustomerServiceInfoBlock";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AnonOrderDocumentTemplate,
): React.JSX.Element => {
    const { order } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section
                id="order-detail"
                className="l-capped-width u-margin-bottom--xl u-full-width-title order-list"
            >
                <h2>Order: {order.order_number}</h2>

                {/* The empty-order-status modifier is ALWAYS on: the legacy
                    template gated it on `{% if not orders %}`, but the view
                    never defines `orders`, so the class rendered on every
                    request -- including with-order renders -- and the mobile
                    orders-page margins key on it. */}
                <div className="content__copy--full-width content__orders-page content__orders-page--empty-order-status">
                    <div className="orders">
                        <ul className="orders__list">
                            {order.has_order ? (
                                <li className="orders__list-item">
                                    <div className="content__copy--full-width order-summary-wrapper">
                                        <AccountRichOrderBody
                                            summary={order.summary}
                                            shipped_events={
                                                order.shipped_events
                                            }
                                            unshipped={order.unshipped}
                                        />
                                    </div>
                                </li>
                            ) : order.form_is_bound ? (
                                <li className="orders__list-item">
                                    No orders match your search.
                                </li>
                            ) : (
                                <li className="orders__list-item orders__list-item--empty-order-status">
                                    <h2 className="orders__list-item__title orders__list-item__title--empty-order-status">
                                        You haven&apos;t shopped with us.
                                    </h2>
                                    <p className="orders__list-item__copy orders__list-item__copy--empty-order-status">
                                        Please check back after your first
                                        purchase to view your order details.
                                    </p>
                                    <a className="button" href="/">
                                        Shop now
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>

                {props.cs_info && (
                    <CustomerServiceInfoBlock info={props.cs_info} />
                )}
            </section>
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
